import $ from 'jquery';

class CkediterFold {
  constructor($ckediter, maxHeight, openText, closeText) {
    this.$ckediter = $ckediter;
    this.maxHeight = maxHeight;
    this.openText = openText;
    this.closeText = closeText;
    this.init();
  }
  init() {
    const { $ckediter, maxHeight } = this;
    const ckediter = $ckediter[0];
    if (ckediter._ckediterFoldInit) return;
    ckediter._ckediterFoldInit = true;
    const conentHeight = $ckediter.childAllHeight();
    if (conentHeight > maxHeight) {
      $ckediter.height(maxHeight).addClass('ckediter--limit');
      this.insertDOM();
    }
  }
  insertDOM() {
    const { $ckediter, openText, closeText } = this;
    const $btnToggle = $(`<button class="btn btn--text-primary btn-toggle btn-toggle--off">
          <span class="btn__icon">
            <i class="ri-arrow-drop-down-line btn-toggle__off"></i>
            <i class="ri-arrow-drop-up-line btn-toggle__on"></i>
          </span>
          <span class="btn-toggle__off">${openText}</span>
          <span class="btn-toggle__on">${closeText}</span>
        </button>`);
    $ckediter.wrap($('<div class="ckediter-fold"></div>')).after($btnToggle);
    $btnToggle.on('click', () => {
      if ($btnToggle.hasClass('btn-toggle--off')) this.open();
      else this.close();
    });
  }
  open() {
    const { $ckediter } = this;
    $ckediter.height($ckediter.childAllHeight());
    setTimeout(() => $ckediter.removeClass('ckediter--limit').removeAttr('style'), 200);
  }
  close() {
    const { $ckediter, maxHeight } = this;
    $ckediter.height($ckediter.height());
    setTimeout(() => {
      $ckediter.height(maxHeight).addClass('ckediter--limit');
    });
  }
}

$('[data-ckediter-fold]').each(function () {
  const $this = $(this);
  const {
    openText = '查看更多',
    closeText = '收起内容',
    height = 144,
  } = $this.data('ckediter-fold') || {};
  new CkediterFold($this, height, openText, closeText);
});
